import { useQuery } from '@tanstack/react-query';

import { Gateway } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/gateway/:gatewayId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    gatewayId: string;
}
const queryFn = ({ parkingId, gatewayId }: DTO): Promise<Gateway> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, gatewayId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetGateway };
